import FormConfig from "../formConfig.js";
import CaLock from "@/components/common/calock";
import { Loading } from "element-ui";
import {
  fun_PostAction,
  fun_GetAction,
  fun_Download,
  fun_UploadImg
} from "@/api/index";
import { fun_DownloadFile } from "@/utils/validate";
import NotTerminatedProjectChoose from "../../components/notTerminatedProjectChoose/index.vue";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
export default {
  data() {
    return {
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 表单绑定值
      form: {
        prjName: null, // 招标项目
        section: null, // 标段
        bidSectionCode: null, // 标段（包）编号
        regulators: null, // 行政监督部门
        tenderOpinion: null, // 招标人意见
        terminationNode: null, // 终止节点
        terminationType: null, // 终止类型
        terminationReason: null, // 终止原因
        lockNo: null, // 锁编号
        digitalSignature: null, // 数字签名
        state: null, // 状态
        tenderCorp: null, // 招标人
        tenderBondFlag: null, // 保证金信息标志
        isAudit: null // 是否核验
      },
      // 全局加载
      fullLoading: null,
      // 主键
      id: this.$route.query.id,
      // 操作标识
      controllerFlag: this.$route.query.controllerFlag,
      // 甲方确认
      isTenderSignature: this.$route.query.isTenderSignature,
      // 提示弹窗
      dialog: true,
      // 温馨提示
      dialogTipList: [
        /* {
           type: "text",
           text: "（1）点击添加，添加需要退还至招标人的保证金信息，并填写退还给招标人理由，退还原因，退还说明，退还方式。"
         },
         {
           type: "text",
           text: "（2）该界面录入的投标单位保证金信息为：该项目所有缴纳至公管局的投标单位信息。"
         },
         {
           type: "text",
           text: "（3）点击“添加”按钮，添加需要退还至招标人的保证金信息，若该笔保证金须退还至投标单位，则无须添加，系统会生成对应的退还信息。"
         },
         {
           type: "text",
           text: "（4）若项目存在退还至招标人的保证金信息，则需要招标人的基本户信息通过或者存在对应的基本户变更记录。"
         },
         {
           type: "text",
           text: "（5）若有退还至投标人的保证金信息，若有投标单位基本户未通过并且基本户无对应变更记录，项目选择继续操作，则基本户未通过或者基本户无对应变更记录的投标单位不会生成对应的退还信息。"
         },
         {
           type: "text",
           text: "（6）保证金提交退还申请的投标单位，需要招标人在项目发送中标通知书后，由招标人或者招标代理在“费用管理”--“保证金退还”中操作保证金退还，但需要该投标单位基本户通过或者存在基本户变更记录。"
         },
         {
           type: "text",
           text: "（7）保证金退还无需监管部门和公管局核验，当中标公示期满后次日，即可进行非中标候选人的保证金退还，中标结果公告次日，即可进行非中标人保证金退还。"
         },
         {
           type: "downLoad"
         }*/
      ],
      // 保证金退还信息loading
      refundLoading: false,
      // 退还招标单位保证金信息表头按钮
      refundBtnList: [
        {
          name: "添加",
          type: "success",
          icon: "circle-plus-outline"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 退还招标单位保证金信息绑定数据
      refundFormObj: {
        // 表格数据
        tableData: []
      },
      // 勾选的数据
      refundMultipleSelection: [],
      // 退还招标单位保证金信息绑定验证规则
      refundRules: {
        bidCorpName: [
          {
            required: true,
            message: "请选择投标单位",
            trigger: "blur"
          }
        ],
        retFlagReason: [
          {
            required: true,
            message: "请填写退还给招标人理由",
            trigger: "blur"
          }
        ],
        refundWay: [
          {
            required: true,
            message: "请填写退款方式",
            trigger: "blur"
          }
        ],
        refundReason: [
          {
            required: true,
            message: "请填写退款原因",
            trigger: "blur"
          }
        ]
      },
      // 保证金信息点击下标
      refundFormObjIndex: null,
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 文件
      fileList: [],
      // 不退还申请表模板路径
      url: null,
      // 默认关闭弹窗
      innerVisible: false,
      // 默认关闭弹窗
      refundDialogVisible: false,
      // 加载loading
      refundDataLoading: false,
      // 查询参数绑定值
      refundForm: {
        bidCorpName: null // 投标单位名称
      },
      // 查询条件
      refundFormSearchList: [
        {
          label: "投标单位名称：",
          value: "bidCorpName",
          placeholder: "请输入",
          type: "input"
        }
      ],
      // 表格数据
      refundTableData: [],
      // 表格基础数据
      refundTableColumns: [
        {
          label: "投标单位名称",
          prop: "bidCorpName",
          isShow: true
        },
        {
          label: "投标单位代码",
          prop: "bidCorpCode"
        }
      ],
      // 分页参数
      refundReqPageData: {
        current: 1, // 页码
        size: 10 // 条数
      },
      refundTotal: 0, // 总条数
      // 不退还申请表加载loading
      pictureLoading: false,
      // 不退还申请表格数据
      pictureData: [],
      // 不退还申请表基础数据
      pictureColumns: [
        {
          label: "上传文件名",
          prop: "pictureName"
        },
        {
          label: "操作",
          slotName: "cz"
        }
      ],
      // 不退还申请信息分页参数
      picturePageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      pictureTotal: 0,
      // 图片预览dialog
      imgVisible: false,
      // 图片地址
      imgUrl: null,
      // 悬浮显示
      isShowTooltip: false,
      // 甲方确认表单
      tenderSignedForm: {
        table: null, // 表名
        key: null, // 字段
        recordNumber: null, // 数据编号
        tenderOpinion: null, // 招标人意见
        tenderSignedId: null, // 招标人签章确认编号
        tenderSignedState: null, // 招标人签章状态
        isDeregulation: null, // 添加标记
        esRegulators: null, // 招标人盖章确认的招标监管部门
        esProcessType: null, // 招标人盖章确认的招标监管流程
        esInvitationId: null, // 招标人盖章确认权限编号
        tenderStampData: null, // 招标人盖章的数字签名
        title: null // 判断当前时提交还是退还至招标代理
      },
      // 用于判断状态图片
      flagState: null
    };
  },

  // 注册组件
  components: {
    CaLock,
    NotTerminatedProjectChoose,
    AuditHistoryRecord
  },

  // 模板编译完成
  mounted() {
    // 查看详情
    if (this.controllerFlag === "detail") {
      // 遍历
      this.formConfigList.map(element => {
        // 遍历
        element.formConfigList.map(e => {
          // 置灰
          e.disabled = true;
        });
      });
      // 清空按钮
      this.refundBtnList = [];
    }
    // 获取项目信息
    this.fun_Details();
    // 获取不退还申请表路径
    this.fun_GetFileUrl();
  },

  // 自定义方法
  methods: {
    /**
     * 打开弹窗
     */
    fun_GetUnpackDialog() {
      // 打开
      this.dialog = true;
    },
    /**
     * 关闭弹窗
     */
    fun_GetOffDialog() {
      // 关闭
      this.dialog = false;
    },
    /**
     * 获取详情
     * @author shuhua
     */
    fun_Details() {
      // 发起请求
      fun_GetAction("/tenderTermination/detail", {
        id: this.id,
        isTenderSignature: this.isTenderSignature
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data.data;
          // 获取状态用于判断显示图片
          this.flagState = data.data.state;
          // 甲方确认
          this.fun_GetTenderSignature(data);
          // 修改内容
          this.fun_updateFormConfig();
        }
      });
    },

    /**
     * 设置表头
     * @author shuhua
     */
    fun_updateFormConfig(operationType) {
      // 存在保证金信息
      if (this.form.tenderBondFlag === "1") {
        // 插入退还招标单位保证金信息
        this.formConfigList.splice(1, 0, {
          title: "退还招标单位保证金信息",
          name: "2",
          icon: "",
          formConfigList: [
            {
              label: "",
              type: "slot",
              class: "list formList",
              slotName: "refundData",
              widht: "100%;"
            },
            {
              label: "文件上传：",
              type: "slot",
              slotName: "refundFile",
              tipContent: "请上传jpg，gif或png格式的图片"
            }
          ]
        });
        // 获取保证金退还信息
        this.fun_RefundBidBondList();
        // 不是选择项目的情况
        if (operationType !== "choose") {
          // 插入不退还申请表
          this.formConfigList.splice(2, 0, {
            title: "不退还申请表",
            name: "3",
            icon: "",
            formConfigList: [
              {
                label: "",
                type: "slot",
                class: "formList",
                slotName: "pictureData",
                width: "100%;"
              }
            ]
          });
          // 操作类型不是新增的场合
          if (this.controllerFlag !== "insert") {
            // 不退还申请表一览
            this.fun_MyFileList();
          }
        }
      } else {
        // 获取长度
        let index = this.formConfigList.length;
        // 遍历
        while (index--) {
          // 匹配退还招标单位保证金信息
          if (this.formConfigList[index].title === "退还招标单位保证金信息") {
            // 删除
            this.formConfigList.splice(index, 1);
          }
          // 匹配不退还申请表
          if (this.formConfigList[index].title === "不退还申请表") {
            // 删除
            this.formConfigList.splice(index, 1);
          }
        }
      }
    },

    /**
     * 已发公告（未终止）的项目选择
     * @author shuhua
     */
    fun_NotTerminatedProjectChoose() {
      // 打开弹窗
      this.$refs.notTerminatedProjectChoose.dialogVisible = true;
    },

    /**
     * 项目基本信息赋值
     * @author shuhua
     */
    fun_NotTerminatedProject(e) {
      // 项目名称
      this.form.prjName = e.prjName;
      // 标段（包）编号
      this.form.bidSectionCode = e.id;
      // 标段
      this.form.section = e.section;
      // 招标投标监管部门
      this.form.regulators = e.regulators;
      // 招标人
      this.form.tenderCorp = e.tenderCorp;
      // 保证金信息标志
      this.form.tenderBondFlag = e.tenderBondFlag;
      // 是否核验
      this.form.isAudit = e.isAudit;
      // 修改内容
      this.fun_updateFormConfig("choose");
    },

    /**
     * 清空项目信息
     * @author shuhua
     */
    fun_ClearNotTerminatedProject() {
      // 标段（包）编号
      this.form.bidSectionCode = null;
      // 项目名称
      this.form.prjName = null;
      // 标段
      this.form.section = null;
      // 行政监督部门
      this.form.regulators = null;
    },

    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },

    /**
     * 关联保证金投标单位选择
     * @author shuhua
     */
    fun_RefundCorpNameChoose(index) {
      // 标段包编号为空
      if (!this.form.bidSectionCode) {
        // 提示信息
        this.$alert("请先选择招标项目！", "warning");
        return;
      }
      // 存储点击的下标
      this.refundFormObjIndex = index;
      // 打开弹窗
      this.refundDialogVisible = true;
      // 打开弹窗
      this.innerVisible = true;
      // 获取一览
      this.fun_WinningRefundSelectList();
    },

    /**
     * 撤回一览
     */
    fun_WinningRefundSelectList() {
      // 打开加载loading
      this.refundDataLoading = true;
      // 发起请求
      fun_PostAction("/winningPublicity/winningRefundSelectList", {
        ...this.refundForm,
        ...this.refundReqPageData,
        tenderReference: this.form.bidSectionCode
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 中标候选人信息
          this.refundTableData = data.records;
          // 总条数
          this.refundTotal = data.total;
          // 关闭加载loading
          this.refundDataLoading = false;
        } else {
          // 错误提示
          this.$message.error(msg);
          // 关闭加载loading
          this.refundDataLoading = false;
        }
      });
    },

    /**
     * 关联保证金投标单位选择
     * @author shuhua
     */
    fun_SetRefundCorp(e) {
      // 询问框
      this.$confirm(
        '<span style="color:red">请确定<strong>' +
          e.val.bidCorpName +
          "</strong>的保证金是要 <strong> 退还至招标人 </strong>吗？</span>",
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].bidCorpName =
          e.val.bidCorpName;
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].bidCorpCode =
          e.val.bidCorpCode;
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].conSeqNo =
          e.val.conSeqNo;
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].refundId =
          e.val.refundId;
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].refundCorpId =
          e.val.basicInfoId;
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].retFlag = "是";
        // 是否核验
        this.form.isAudit = e.val.isAudit;
        // 关闭弹窗
        this.refundDialogVisible = false;
      });
    },

    /**
     * 获取保证金退还信息
     * @author shuhua
     */
    fun_RefundBidBondList() {
      // 打开加载loading
      this.refundLoading = true;
      // 发起请求
      fun_PostAction("/winningPublicity/winningRefundBidList", {
        ...this.reqPageData,
        tenderReference: this.form.bidSectionCode,
        dataType: "3",
        flag: this.type === "detail" ? "2" : "0"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 声明变量
          let d = data.records;
          // 遍历
          d.map(element => {
            // 赋值
            element.retFlag = "是";
            // 赋值
            element.bidCorpName = element.bidCorpName
              ? element.bidCorpName.indexOf("@") > 0
                ? element.bidCorpName.substring(
                    0,
                    element.bidCorpName.indexOf("@")
                  )
                : element.bidCorpName
              : "";
          });
          // 赋值
          this.refundFormObj.tableData = d;
          // 总条数
          this.total = data.total;
          // 关闭加载loading
          this.refundLoading = false;
        } else {
          // 错误提示
          this.$message.error(msg);
          // 关闭加载loading
          this.refundLoading = false;
        }
      });
    },

    /**
     * 获取文件模板路径
     * @author shuhua
     */
    fun_GetFileUrl() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "不退还申请表"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 不退还申请表路径
          this.url = data;
        }
      });
    },

    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_RefundClick(e) {
      switch (e) {
        case "添加":
          // 调用添加方法
          var newValue = {
            bidCorpName: null,
            bidCorpCode: null,
            retFlag: null,
            retFlagReason: null,
            refundWay: null,
            refundReason: null,
            refundDescription: null
          };
          //添加新的行数
          this.refundFormObj.tableData.push(newValue);
          break;
        default:
          // 判断是否勾选
          if (this.refundMultipleSelection.length <= 0) {
            // 提示信息
            this.$alert("最少选择一条数据！", "warning");
            return;
          }
          // 弹出询问confirm
          this.$confirm("是否确定删除选中数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 遍历
            this.refundMultipleSelection.map((value, index) => {
              // 遍历
              this.refundFormObj.tableData.map((v, i) => {
                // 匹配已选中的
                if (value.index === v.index) {
                  // 删除勾选的数据
                  this.refundFormObj.tableData.splice(i, 1);
                }
              });
            });
            // 清除选中数据
            this.$refs.refundMultipleTable.clearSelection();
          });
      }
    },

    /**
     * 上传文件
     */
    fun_FileChange(file, fileList) {
      // 获取文件后缀名
      const suffix = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      // 这里限定上传文件文件类型必须为jpg，gif或png，如果文件类型不符，提示错误信息
      if (suffix == "jpg" || suffix == "gif" || suffix == "png") {
        if (fileList.length === 1) {
          this.fileList = fileList;
        }
        if (fileList.length > 1) {
          const list = fileList.pop();
          this.fileList = [list];
        }
      } else {
        // 清除文件
        this.$refs.fileUpload.clearFiles();
        // 提示错误消息
        this.$message.error("图片格式有误，请上传jpg或gif或png格式的图片");
        // 返回
        return false;
      }
    },

    /**
     * 移除文件
     * @author shuhua
     */
    handleRemove(file) {
      // 文件集合为空
      this.fileList = [];
    },

    /**
     * 列表添加class
     */
    addClass(row, column, rowIndex, columnIndex) {
      // 判断是序号
      if (row.column.type === "index") {
        return "index";
      }
    },

    /**
     * 添加时执行的方法
     * @author shuhua
     */
    tableRowClassName(row, rowIndex) {
      // 给每一行新增一个下标
      row.row.index = row.rowIndex;
    },

    /**
     * 悬浮显示
     */
    inputOnMouseOver(event) {
      const target = event.target;
      // 判断是否开启tooltip功能
      if (target.offsetWidth < target.scrollWidth) {
        this.isShowTooltip = false;
      } else {
        this.isShowTooltip = true;
      }
    },

    /**
     * 获取不退还申请表一览
     * @author shuhua
     */
    fun_MyFileList() {
      // 打开加载loading
      this.pictureLoading = true;
      // 发起请求
      fun_PostAction("/tenderPictureinfor/tenderPictureinforList", {
        ...this.picturePageData,
        recordNumber: this.id,
        type: "31"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 中标候选人信息
          this.pictureData = data.records;
          // 总条数
          this.pictureTotal = data.total;
          // 关闭加载loading
          this.pictureLoading = false;
        } else {
          // 错误提示
          this.$message.error(msg);
          // 关闭加载loading
          this.pictureLoading = false;
        }
      });
    },

    /**
     * 图片预览
     */
    fun_LookImg(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          if (res.data.type === "application/json") {
            this.$message.error("文件不存在！");
            return;
          }
          // 存储this
          const _this = this;
          const data = new Blob([res.data]);
          this.fun_GetBlobToBase64(data).then(res => {
            // 打开弹窗
            this.imgVisible = true;
            // 回显图片
            _this.imgUrl = res;
          });
        }
      });
    },

    /**
     * 转为base64URL
     * @author 滕威
     */
    fun_GetBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
        // 创建文件对象
        const reader = new FileReader();
        reader.onload = e => {
          resolve(e.target.result);
        };
        reader.readAsDataURL(blob);
        reader.onerror = () => {
          reject(new Error("文件流异常！"));
        };
      });
    },

    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },

    /**
     * 行政监督部门下拉框值改变事件
     * @author shuhua
     */
    fun_ChangeRegulators(e) {
      // 赋值
      this.form.regulators = e.code;
    },

    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },

    /**
     * 招标终止操作
     * @author shuhua
     */
    fun_TenderTerminationInsUpd(state) {
      // 保存
      if (state === "bc") {
        this.fun_SaveOrUpdate(state);
      } else {
        // 表单验证
        this.$refs.collapseForm.$refs.enInform.validate(valid => {
          // 验证通过
          if (valid) {
            // 开启弹窗
            this.$refs.caLock.dialogCalock = true;
            // 签名数据, 交易人名称和日期
            this.$refs.caLock.data =
              this.form.bidSectionCode +
              this.form.prjName +
              this.form.section +
              this.form.terminationNode +
              this.form.terminationType +
              this.form.regulators;
            // 状态
            this.$refs.caLock.state = state;
          } else {
            return false;
          }
        });
      }
    },

    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 操作状态
      this.form.state = state;
      // 存在保证金信息
      if (this.form.tenderBondFlag === "1") {
        // 操作标识
        var tenderFlag = false;
        // 退还至招标人编号
        var accountBasicInfoId = "";
        // 遍历
        this.refundFormObj.tableData.map(item => {
          // 判断是否选择单位
          if (!item.refundCorpId) {
            // 操作标识
            tenderFlag = true;
          }
          accountBasicInfoId += item.refundCorpId + ",";
        });
        // 添加退还招标人单位，是否有选中投标单位
        if (tenderFlag) {
          // 消息提示
          this.$alert(
            "你添加退还至招标人的投标单位信息，但未选择具体的投标单位，请修改后再提交！",
            "warning"
          );
          return;
        }
        // 参数
        var parameters = new Array();
        // 招标编号
        parameters[0] = this.form.bidSectionCode;
        // 第一名
        parameters[1] = "";
        // 退还至招标人
        parameters[2] = accountBasicInfoId;
        // 放弃中标界面验证投标单位基本户编号
        parameters[3] = "";
        // 界面验证标志
        parameters[4] = "0";
        // 检查投标单位基本户
        this.fun_CheckBasicAccount(parameters);
      } else {
        // 提交的方法
        this.fun_Submit();
      }
    },

    /**
     * 检查投标单位基本户
     * @author shuhua
     */
    fun_CheckBasicAccount(parameters) {
      // 发起请求
      fun_PostAction("/winningPublicity/checkBasicAccount", {
        parameters: parameters
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 招标人基本户信息未核验通过
          if (data.tenderAccount === false) {
            // 错误提示
            this.$alert(data.msg, "warning");
            return;
          }
          // 投标单位基本户信息未核验通过
          if (data.account === false) {
            // 询问框
            this.$confirm(data.msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              // 提交的方法
              this.fun_Submit();
            });
          } else {
            // 提交的方法
            this.fun_Submit();
          }
        }
      });
    },

    /**
     * 提交的方法
     * @author shuhua
     */
    fun_Submit() {
      // 表单
      var formData = new FormData();
      // 存在保证金信息
      if (this.form.tenderBondFlag === "1") {
        // 创建退还单位保证金信息集合
        var refundBids = new Array();
        // 遍历
        this.refundFormObj.tableData.map(e => {
          // 退还信息
          var refundBid = { conSeqNo: "", refundId: "", bidCorpCode: "" };
          // 确认来账编号
          refundBid.conSeqNo = e.conSeqNo;
          // 退还编号
          refundBid.refundId = e.refundId;
          // 单位编号
          refundBid.bidCorpCode = e.refundCorpId;
          // 退还信息集合
          refundBids.push(refundBid);
        });
        // 来账信息与退还编号
        formData.append("refundBids", JSON.stringify(refundBids));
      }
      //
      // 招标终止信息
      formData.append("tenderTermination", JSON.stringify(this.form));
      // 保证金退还信息
      formData.append("list", JSON.stringify(this.refundFormObj.tableData));
      // 上传附件不为空
      if (this.fileList.length > 0) {
        // 退还保证金附件
        formData.append("refundFile", this.fileList[0].raw);
      }
      // 操作标志
      formData.append("controllerFlg", this.controllerFlag);
      // 招标人
      formData.append("tenderCorp", this.form.tenderCorp);
      // 状态
      formData.append("state", this.form.state);
      // 加载框
      this.fun_Loading();
      // 发起请求
      fun_UploadImg("/tenderTermination/saveOrUpdate", formData, 0).then(
        res => {
          // 解构res.data
          const { result, msg, data } = res.data;
          // 操作成功
          if (result) {
            // 关闭遮罩
            this.fullLoading.close();
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.$router.back();
          } else {
            // 关闭遮罩
            this.fullLoading.close();
            // 错误消息提示
            this.$message.error(msg);
          }
        }
      );
    },

    /**
     * 甲方确认
     */
    fun_GetTenderSignature(data) {
      this.form.tenderOpinion = data.data.tenderOpinion; // 招标人意见
      this.tenderSignedForm.table = data.data.tableName; // 表名
      this.tenderSignedForm.key = data.data.keyState; // 字段
      this.tenderSignedForm.recordNumber = data.data.id; // 数据编号
      this.tenderSignedForm.tenderOpinion = data.tenderOpinion; // 招标人意见
      this.tenderSignedForm.tenderSignedId = data.tenderSignedId; // 招标人签章确认编号
      this.tenderSignedForm.tenderSignedState = data.tenderSignedState; // 招标人签章状态
      this.tenderSignedForm.isDeregulation = data.isDeregulation; // 添加标记
      this.tenderSignedForm.esRegulators = data.esRegulators; // 招标人盖章确认的招标监管部门
      this.tenderSignedForm.esProcessType = data.esProcessType; // 招标人盖章确认的招标监管流程
      this.tenderSignedForm.esInvitationId = data.esInvitationId; // 招标人盖章确认权限编号
      this.tenderSignedForm.tenderStampData = data.tenderStampData; // 招标人盖章的数字签名
    },

    /**
     * 甲方确认提交与退还
     */
    fun_TenderStamp(e) {
      // 如果招标人意见不为空
      if (this.form.tenderOpinion != "" && this.form.tenderOpinion != null) {
        // 设置招标人意见
        this.tenderSignedForm.tenderOpinion = this.form.tenderOpinion;
      }
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据, 交易人名称和日期
      this.$refs.caLock.data = this.form.id + this.form.tenderPrjName;
      // 状态
      this.$refs.caLock.state = e;
      this.$refs.caLock.tenderSigned = e;
      this.$refs.caLock.tenderSignedForm = this.tenderSignedForm;
    },

    /**
     * 退还招标单位保证金列表勾选事件
     * @author shuhua
     */
    fun_RefundSelectionChange(e) {
      // 赋值勾选数组
      this.refundMultipleSelection = e;
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取保证金退还信息
      this.fun_RefundBidBondList();
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_RefundLimitChange(e) {
      // 获取每页显示条数
      this.refundReqPageData.size = e;
      // 获取一览表格数据
      this.fun_WinningRefundSelectList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_RefundPageChange(e) {
      // 获取当前页码
      this.refundReqPageData.current = e;
      // 获取一览表格数据
      this.fun_WinningRefundSelectList();
    },

    fun_RefundSearch() {
      // 重置分页
      this.refundReqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_WinningRefundSelectList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取保证金退还信息
      this.fun_RefundBidBondList();
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_PictureLimitChange(e) {
      // 获取每页显示条数
      this.picturePageData.size = e;
      // 获取一览表格数据
      this.fun_MyFileList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PicturePageChange(e) {
      // 获取当前页码
      this.picturePageData.current = e;
      // 获取一览表格数据
      this.fun_MyFileList();
    },

    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      // 全局加载
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
    },

    /**
     * 提示显示内容
     */
    fun_GetTip(i) {
      return `（${i +
        1}）项目存在退还至招标人的保证金信息，则要求招标代理填写完保证金退还信息后，须上传附件。<el-button type="text"> @click="fun_Download(${
        this.url
      })">《不退还申请表》模板下载</el-button>`;
    }
  }
};
